
import { formatCurrency } from "@/lib/utils";
import { useCurrency } from "@/contexts/CurrencyContext";

interface InventoryCostSummaryProps {
  items: any[];
}

export function InventoryCostSummary({ items = [] }: InventoryCostSummaryProps) {
  const { currency } = useCurrency();
  const totalItems = items.length;
  const totalDailyRate = items.reduce(
    (sum, item) => sum + (item.cost_per_unit || 0) * (item.quantity || 1),
    0
  );

  return (
    <div className="bg-card/60 backdrop-blur-xl border border-white/10 p-4 rounded-xl shadow-lg mt-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-8 flex-1">
          <div>
            <span className="text-sm text-white/70 block mb-1">Total Items</span>
            <p className="font-bold text-2xl text-white">{totalItems}</p>
          </div>
          <div className="h-12 border-r border-border/30"></div>
          <div>
            <span className="text-sm text-white/70 block mb-1">Total Value</span>
            <p className="font-bold text-2xl text-white">{formatCurrency(totalDailyRate, currency)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
